export enum EngagementPlatformType {
  Native = 'native',
  Youtube = 'youtube',
  Vimeo = 'vimeo',
}
